import { useContext } from "react";
import { PrimeReactContext } from "primereact/api";
import { ThemeStateProps } from "../../models/theme";
import { shallowEqual } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../hooks/ReduxHooks";
import { Themes } from "../../models/enums/enums";
import { actions } from "../../store/slices/ThemeSlice";

const ThemeButton = () => {
  const { theme } = useAppSelector(
    (state: { theme: ThemeStateProps }) => state.theme,
    shallowEqual
  );
  const dispatch = useAppDispatch();
  const { changeTheme } = useContext(PrimeReactContext);

  const toggleTheme = () => {
    if (changeTheme) {
      const newTheme = theme === Themes.Light ? Themes.Dark : Themes.Light;
      changeTheme(
        `md-${theme}-indigo`,
        `md-${newTheme}-indigo`,
        "app-theme",
        () => dispatch(actions.changeTheme(newTheme))
      );
    }
  };

  return (
    <div
      className="flex align-items-center justify-content-between w-full px-3 py-2 cursor-pointer hover:surface-hover border-round transition-duration-200"
      onClick={toggleTheme}
    >
      <div className="flex align-items-center gap-2">
        <i
          className={`pi ${
            theme === Themes.Light
              ? "pi-sun text-yellow-500"
              : "pi-moon text-blue-400"
          } text-xl`}
        ></i>
        <span className="font-medium">
          Tema {theme === Themes.Light ? "Claro" : "Oscuro"}
        </span>
      </div>
    </div>
  );
};

export default ThemeButton;
